<template>
	<div class="page-content__content">
		<SuppliersTable/>
	</div>
</template>


<script>
import { provide } from 'vue';
import SuppliersTable from "@/components/sections/Suppliers/SuppliersTable.vue";


export default {
	name: "SuppliersPage",
	components: {SuppliersTable},
	props: {	
		legal: {
			type: Array,
			default: () => []
		},
		edi: {
			type: Array,
			default: () => []
		},
		productControl: {
			type: Array,
			default: () => []
		}
	},
	setup(props) {
		provide('legal', props.legal)
		provide('edi', props.edi)
		provide('productControl', props.productControl)
	},
}
</script>


